import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n';

export default function Add({ openAssignmentModal }) {
  function openModal() {
    openAssignmentModal(true);
  }

  return (
    <div className="mt10 tw-bg-white">
      <button
        aria-haspopup="dialog"
        aria-label="Create New"
        className="btn btn--green"
        type="button"
        onClick={openModal}
      >
        {I18n.t('create_new')}
      </button>
    </div>
  );
}

Add.propTypes = {
  openAssignmentModal: PropTypes.func.isRequired
};
